
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/[...path]",
      function () {
        return require("private-next-pages/landing/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/[...path]"])
      });
    }
  